import App from 'src/containers/App/App'

export default App
